const CanvaPlusIcon = (props) => {
  const { size = 24, color = "white" } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6421 15.1558C15.5157 15.1558 15.4045 15.263 15.2888 15.497C13.9821 18.1587 11.7253 20.0419 9.11364 20.0419C6.09386 20.0419 4.22382 17.3036 4.22382 13.5206C4.22382 7.11242 7.77811 3.40734 10.9 3.40734C12.3588 3.40734 13.2497 4.32826 13.2497 5.79378C13.2497 7.53308 12.266 8.45401 12.266 9.06742C12.266 9.34279 12.4365 9.5095 12.7746 9.5095C14.133 9.5095 15.7273 7.94152 15.7273 5.72645C15.7273 3.57867 13.8664 2 10.7447 2C5.58527 2 1 6.80494 1 13.4532C1 18.5993 3.92536 22 8.43905 22C13.2298 22 16 17.2118 16 15.6576C16 15.3135 15.8248 15.1558 15.6421 15.1558Z"
        fill={color}
      />
      <path d="M16 10.1582H22.3158" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.1582 13.3158V7" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CanvaPlusIcon;
